import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "436px",
    width: "708px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface TaskData {
  userName: string;
  lastLogin: string;
  contactNumber: string;
  email: string;
  status: string;
  role?: string;
  providerAccess?: string;
}

interface ViewAdminDialogProps {
  isOpen: boolean;
  dialogHeading: string;
  handleClose: () => void;
  taskData: TaskData;
}

const ViewAdminDialog = ({
  isOpen = false,
  taskData,
  handleClose,
  dialogHeading = "Your Heading Here...",
}: ViewAdminDialogProps) => {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          {taskData ? (
            <div
              style={{
                padding: "24px 16PX",
                display: "grid",
                gap: "24px 16px",
                gridTemplateColumns: "1fr 1fr",
                border: "1px solid #E8E8E8",
              }}
            >
              <p>
                <strong>Admin Name:</strong>
                {taskData?.userName}
              </p>
              <p>
                <strong>Last Login:</strong> {taskData?.lastLogin || ""}
              </p>
              <p>
                <strong>Contact Number:</strong> {taskData?.contactNumber || ""}
              </p>
              <p>
                <strong>Email:</strong> {taskData?.email || ""}
              </p>
              <p>
                <strong>Role:</strong> {taskData?.role || ""}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                {taskData?.status
                  ? taskData?.status?.replace(/([a-z])([A-Z])/g, "$1 $2")
                  : ""}
              </p>
              <p>
                <strong>Provider Access:</strong>{" "}
                {taskData?.providerAccess === "yes" ? "Yes" : taskData?.providerAccess === "no" ? "No" : "-"}
              </p>
            </div>
          ) : (
            <p>No task data available</p>
          )}
        </DialogContent>
        <DialogActions>
          <div className="p-2">
            <Button
              // disabled={!isValid} // Button disabled if form is invalid or submitting
              label={TEXT_CONSTANTS?.CLOSE}
              variant="contained"
              onClickCb={handleClose}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginRight: "6px",
              }}
            ></Button>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default ViewAdminDialog;
